import Show from '@components/helpers/Show'
import { clsx } from 'clsx'
import { FC, PropsWithChildren } from 'react'
import './index.scss'
import Typography from '../../typography'

interface ContentItemProps extends PropsWithChildren {
    label?: string
    className?: string
}

const ContentItem: FC<ContentItemProps> = ({ children, label, className }) => {
    return (
        <div className={clsx(['content-item', className])} data-testid={label}>
            <Show when={label}>
                <Typography
                    component="h3"
                    variant="xs-bold"
                    className="content-item-label"
                >
                    {label}
                </Typography>
            </Show>
            <Typography className="content-item-content" variant="s-regular">
                {children}
            </Typography>
        </div>
    )
}

export default ContentItem
